import React, { useState } from "react";
import {
  Card,
  Table,
  Form,
  Dropdown,
  Row,
  Col,
} from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";

import "bootstrap/dist/css/bootstrap.min.css";
import TrainingListHeader from "../../../components/hrm/training/TrainingListHeader";
import EditTrainingModal from "../../../components/modals/hrm/training/traininglist/EditTrainingModal";
import DeleteTrainingModal from "../../../components/modals/hrm/training/traininglist/DeleteTrainingModal";

export default function TrainingListPage() {
  const [search, setSearch] = useState("");
  const [editShow, setEditShow] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
const data = [
  {
    title: "Git Training",
    trainer: "Anthony Lewis",
    cost: "$200",
    status: "Active",
    desc: "Version control and code collaboration.",
    date: "12 Jan 2024 - 12 Feb 2024",
    img: "assets/img/users/user-32-1.jpg",
    count: "+4",
  },
  {
    title: "HTML Training",
    trainer: "Brian Villalobos",
    cost: "$100",
    status: "Active",
    desc: "Basics of web page structure and markup.",
    date: "17 Jan 2024 - 17 Feb 2024",
    img: "assets/img/users/user-09.jpg",
    count: "+3",
  },

  // NEW DATA 👇
  {
    title: "CSS Advanced",
    trainer: "Sophia Turner",
    cost: "$150",
    status: "Active",
    desc: "Flexbox, Grid, and responsive design techniques.",
    date: "20 Jan 2024 - 20 Feb 2024",
    img: "assets/img/users/user-10.jpg",
    count: "+5",
  },
  {
    title: "JavaScript Basics",
    trainer: "Daniel Smith",
    cost: "$180",
    status: "Active",
    desc: "Core concepts of JavaScript and ES6 features.",
    date: "25 Jan 2024 - 25 Feb 2024",
    img: "assets/img/users/user-11.jpg",
    count: "+6",
  },
  {
    title: "React JS Training",
    trainer: "Emma Johnson",
    cost: "$250",
    status: "Active",
    desc: "Building UI with React components and hooks.",
    date: "01 Feb 2024 - 01 Mar 2024",
    img: "assets/img/users/user-12.jpg",
    count: "+8",
  },
  {
    title: "Node JS Training",
    trainer: "Michael Brown",
    cost: "$220",
    status: "Inactive",
    desc: "Backend development with Node.js and Express.",
    date: "05 Feb 2024 - 05 Mar 2024",
    img: "assets/img/users/user-13.jpg",
    count: "+4",
  },
  {
    title: "MongoDB Training",
    trainer: "Olivia Davis",
    cost: "$160",
    status: "Active",
    desc: "NoSQL database concepts and CRUD operations.",
    date: "10 Feb 2024 - 10 Mar 2024",
    img: "assets/img/users/user-14.jpg",
    count: "+3",
  },
  {
    title: "UI/UX Design",
    trainer: "William Garcia",
    cost: "$190",
    status: "Active",
    desc: "User experience principles and interface design.",
    date: "15 Feb 2024 - 15 Mar 2024",
    img: "assets/img/users/user-15.jpg",
    count: "+7",
  },
];
  const filtered = data.filter((d) =>
    d.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
     <div 
style={{ padding: "15px", background: "#f8f9fa",  }} >

<TrainingListHeader/>


           <Card className="training-card mt-3">
        {/* HEADER */}
        <Card.Header style={{  background: "#ffffff",  }} className="d-flex justify-content-between flex-wrap">
          <h5>Training List</h5>

          <Dropdown>
            <Dropdown.Toggle className="text-dark bg-white border border-1">
              Sort By : Last 7 Days
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item>Recently Added</Dropdown.Item>
              <Dropdown.Item>Ascending</Dropdown.Item>
              <Dropdown.Item>Descending</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Card.Header>

        {/* FILTER */}
        <div className="p-3 d-flex justify-content-between flex-wrap gap-2">
          <div>
            Row Per Page
            <Form.Select size="sm" className="d-inline w-auto mx-2">
              <option>10</option>
            </Form.Select>
            Entries
          </div>

          <Form.Control
            placeholder="Search"
            className="search-box"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover className="align-middle">
            <thead className="thead-light">
              <tr>
                <th>
                                   <Form.Check />
                                 </th>
                <th>Training Type</th>
                <th>Trainer</th>
                <th>Employee</th>
                <th>Time Duration</th>
                <th>Description</th>
                <th>Cost</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item, i) => (
                <tr key={i}>
                    <td>
                           <Form.Check />
                    </td>
                  <td>{item.title}</td>

                  <td>
                    <div className="d-flex align-items-center">
                      <img src={item.img} className="trainer-img" />
                      <span className="ms-2">{item.trainer}</span>
                    </div>
                  </td>

                  <td>
                    <div className="avatar-group">
                      <img src={item.img} />
                      <img src={item.img} />
                      <img src={item.img} />
                      <div className="more">{item.count}</div>
                    </div>
                  </td>

                  <td>{item.date}</td>
                  <td>{item.desc}</td>
                  <td>{item.cost}</td>

                  <td>
                    <span className="status-badge">
                      ● Active
                    </span>
                  </td>

                  <td>
                    <div className="actions">
                      <FiEdit2 onClick={() => setEditShow(true)} />
                      <FiTrash2 onClick={() => setDeleteShow(true)} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* MODALS */}
      <EditTrainingModal show={editShow} onHide={() => setEditShow(false)} />
      <DeleteTrainingModal show={deleteShow} onHide={() => setDeleteShow(false)} />

      {/* CSS */}
      <style>{`
        .training-card {
          border-radius: 5px;
          background: #ffffff;

        }

        .btn-white {
          background: white;
          border: 1px solid #ddd;
        }

        .search-box {
          max-width: 200px;
        }

        .trainer-img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
        }

        /* Avatar group */
        .avatar-group {
          display: flex;
          align-items: center;
        }

        .avatar-group img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-left: -8px;
          border: 2px solid white;
        }

        .avatar-group img:first-child {
          margin-left: 0;
        }

        .avatar-group .more {
          background: #ff6b2c;
          color: white;
          font-size: 12px;
          padding: 5px 7px;
          border-radius: 50%;
          margin-left: -8px;
        }

        /* Status */
        .status-badge {
          background: #16a34a;
          color: white;
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 12px;
        }

        /* Actions */
        .actions svg {
          cursor: pointer;
          margin-right: 10px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .search-box {
            width: 100%;
          }

          table {
            font-size: 12px;
          }
        }
      `}</style>
     </div>
    </>
  );
}